// Adapted from https://usehooks.com/useLocalStorage/
import { useState } from 'react';

import localStorage from './localStorage';

const useLocalStorage = (key, initialValue, transformFn = JSON.parse) => {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // Get from local storage by key
            const item = localStorage.getItem(key);
            // Parse stored json or if none return initialValue
            return item ? transformFn(item) : initialValue;
        } catch (error) {
            return initialValue;
        }
    });

    // Return a wrapped version of useState's setter function that ...
    // ... persists the new value to localStorage.
    const setValue = (value) => {
        // Allow value to be a function so we have same API as useState
        const valueToStore = value instanceof Function ? value(storedValue) : value;
        // Save state
        setStoredValue(valueToStore);
        // Save to local storage
        localStorage.setItem(key, JSON.stringify(valueToStore));
    };

    return [storedValue, setValue];
};

export default useLocalStorage;
